export const QuestionChild = [
  "მე არასდროს მიტარებია მოტოციკლი",
  "მე არასდროს მიღალატია მეგობრისთვის",
  "მე არასდროს მიმღერია კარაოკე",
  "მე არასდროს მომიტეხავს ხელი ან ფეხი",
  "მე არასდროს მყოლია შეყვარებული",
  "მე არასდროს მიჩხუბია ხალხის თანდასწრებით",
  "მე არასდროს მქონია ტყუილი სოციალური გვერდი",
  "მე არასდროს შემშლია ავტობუსი ან მარშუტკა",
  "მე არასდროს ვყოფილვარ შერცხვენილი საჯაროდ",
  "მე არასდროს მდომებია პოპულარობა",
  "მე არასდროს გამიჩენია ცეცხლი",
  "მე არასდროს გავმხდარვარ პოპულარული სოციალურ ქსელში",
  "მე არასდროს გამოვსულვარ სიტყვით 100 ადამიანის წინ",
  "მე არასდროს ვყოფილვარ საზღვარგარეთ",
  "მე არასდროს დამილევია ალკოჰოლი",
  "მე არასდროს მიცდია დიეტა",
  "მე არასდროს გამიჩუქებია საჩუქარი",
  "მე არასდროს მიჭამია მთლიანი პიცა",
  "მე არასდროს დამიტოვია კევი საზოგადოებრივ ადგილას",
  "მე არასდროს მიმიღია მონაწილეობა მარათონში",
  "მე არასდროს ჩამძინებია ონლაინ გაკვეთილზე",
  "მე არასდროს მომიპარავს რაღაც რას 10ლარზე მეტად ფასობს",
  "მე არასდროს მომწონებია სიმღერა პაპიტო",
  "მე არასდროს დავნიძლავებულვარ",
  "მე არასდროს დამიდგამს დრამა სკოლაში",
  "მე არასდროს გადამიწერია ტესტი",
  "მე არასდროს გამისინჯავს სიგარეტი",
  "მე არასდროს მიმიღია მოანწილება მასშტაბურ შოუში",
];

export const QuestionAdult = [
  "მე არასდროს გადამიღია სელფი აბაზანაში",
  "მე არასდროს მქონია ურთიერთობა მეგობრობაზე მეტი და სიყვარულზე ნაკლები",
  "მე არასდროს ჩამიდენია არალეგალური საქმე",
  "მე არასდროს ვყოფილვარ ბორკილებში",
  "მე არასდროს მყვარებია ჩემი ძმის/დის უახლოესი მეგობარი",
  "მე არასდროს მიკოცნია უცნობისთვის",
  "მე არასდროს გამჩენია ეჭვი ჩემს ორიენტაციაზე",
  "მე არასდროს გამიგზავნია ნუდები",
  "მე არასდროს ჩამძინებია სექსის დროს",
  "მე არასდროს ვყოფილვარ სტრიპტიზ კლუბში",
  "მე არასდროს მქონია გრუპავოი",
  "მე არასდროს მომიწევია მოსაწევი",
  "მე არასდროს გამიკუებია სექსის დროს",
  "მე არასდროს მიმიღია ნარკოტიკი",
];

export const QuestionCouples = [
  "მე არასდროს გამისინჯავს მარიხუანა",
  "მე არასდროს მიკოცნია საუკეთესო მეგობრითვის",
  "მე არასდროს მიკოცნია საერთო სქესისთვის",
  "მე არასდროს გავუგდივარ ბარიდან დაცვას",
  "მე არასდროს ვყოფილვარ ღია ურთიერთობაში",
  "ჩემთვის არადროს დაუდიათ",
  "მე არასდროს დამილევია გათიშვამდე",
  "მე არასდროს მქონია ყალბი პირადობის/მართვის მოწმობა",
  "მე არასდროს მიღალატია შეყვარებულისთვის",
  "მე არასდროს მიკოცნია 24 საათში ერთზე მეტი ადამიანისთვის",
  "მე არასდროს მქონია “ერთი ღამით სიყვარული”",
  "მე არასდროს გამიკეთებია ტატუ",
  "მე არასდროს გადამირჩენია ვინმეს სიცოცხლე",
  "მე არასდროს მიცეკვია თვერქი",
  "მე არასდროს მომიტყუებია ჩემი ასაკი",
  "მე არასდროს შემითხზავს ამბავი იმაზე, ვინც არ არსებობს",
  "მე არასდროს მიმიღია მონაწილეობა აქციაში",
  "მე არასდროს მინანია ბოდიში",
  "მე არასდროს მცმია სხვისი ტრუსები",
  "მე არასდროს მითვალთვალია მეზობლისთვის",
  "მე არასდროს ჩამიდენია ისეთი რამ რაც შემდეგ ვინანე",
  "მე არასდროს წამიშლია პოსტი იმის გამო, რომ მოწონებები ვერ ააგროვა",
];
